module.exports = __webpack_public_path__ + "img/solution_cj.5b5aa40e.png";